/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Section2_P1Inputs */

const en_about_section2_p1 = /** @type {(inputs: About_Section2_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Many online JSON tools send your data to a server for processing. This creates security risks, especially when working with sensitive data like API keys, credentials, or production configurations. PureJSON is different:`)
};

const ko_about_section2_p1 = /** @type {(inputs: About_Section2_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`많은 온라인 JSON 도구가 처리를 위해 데이터를 서버로 전송합니다. 이는 API 키, 인증 정보, 프로덕션 설정과 같은 민감한 데이터를 다룰 때 보안 위험을 만듭니다. PureJSON은 다릅니다:`)
};

const ja_about_section2_p1 = /** @type {(inputs: About_Section2_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`多くのオンラインJSONツールは処理のためにデータをサーバーに送信します。これはAPIキー、認証情報、本番設定などの機密データを扱う際にセキュリティリスクを生みます。PureJSONは違います：`)
};

/**
* | output |
* | --- |
* | "Many online JSON tools send your data to a server for processing. This creates security risks, especially when working with sensitive data like API keys, cre..." |
*
* @param {About_Section2_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const about_section2_p1 = /** @type {((inputs?: About_Section2_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Section2_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_about_section2_p1(inputs)
	if (locale === "ko") return ko_about_section2_p1(inputs)
	return ja_about_section2_p1(inputs)
});